export default __webpack_public_path__ + "static/media/benefit_4@2x.f8e41bba.png";